import React, { useEffect, useState } from "react";
import { Accordion, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import classNames from "classnames";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import { Select2Data } from "../../../utils/common";
import {
  getCities,
  getCourses,
  getCourseWiseSpecializations,
  getStates,
  postEnquiryForm,
} from "../../../utils/apis/enquiry_form/Enquiry_Form";
import Submit_Btn from "../common_btn/submit_btn/Submit_Btn";
import "./Common_Form.css";

const Common_Form = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const coursesdata = [
    { id: "lykam_matte", name: "BBA" },
    { id: "glossy_paper", name: "BCA" },
    { id: "premium_card", name: "Diploma" },
  ];

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [statesData, setStatesData] = useState([]);
  const [cities, setCities] = useState([]);
  const [courses, setCourses] = useState([]);
  const [specilization, setSpecilization] = useState([]);

  const GetAllCities = async (id) => {
    const response = await getCities(id);

    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  const GetAllSpecilization = async (id) => {
    const response = await getCourseWiseSpecializations(id);

    if (response?.success) {
      setSpecilization(await Select2Data(response?.data, "specilization_id"));
    }
  };

  useEffect(() => {
    const GetAllStates = async (id) => {
      const response = await getStates(1);

      if (response?.success) {
        setStatesData(await Select2Data(response?.data, "state_id"));
      }
    };

    GetAllStates();

    const getAllCourses = async (id) => {
      // id for profcyma
      const response = await getCourses(6);

      // id for Subdomain
      // const response = await getCourses(1);

      if (response?.success) {
        setCourses(await Select2Data(response?.data, "state_id"));
      }
    };

    getAllCourses();
  }, []);

  // Courses
  const newCourses = [
    { value: 8, label: "Diploma" },
    { value: 9, label: "Graduate" },
    { value: 10, label: "Post Graduate" },
    // { value: "12th_pass", label: "12th Pass" },
    // { value: "10th_pass", label: "10th Pass" },
  ];

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("mobile", data?.contact_no);
    formData.append("state_id", data?.state_id?.value ?? null);
    formData.append("district_id", data?.city_id?.value ?? null);
    formData.append("course_id", data?.course_id?.value ?? null);
    formData.append("specilization_id", data?.specilization_id?.value ?? null);

    // source name
    // formData.append("source_name", "Google_LP");

    // profcyma domain and  api key
    // formData.append("api_key", "profcyma-website");

    // profcyma 46 domain source_name and  api key
    // formData.append("source_name", "Profcyma_Google");
    // formData.append("api_key", "profcyma-new-website");

    // profcyma masterdegreecourses domain source_name and  api key
    // formData.append("source_name", "Profcyma_Google_MBA-WX");
    // formData.append("api_key", "Profcyma_Google_MBA-WX");

    // profcyma onlinemasterdegrees domain source_name and  api key
    formData.append("source_name", "Profcyma_Google_Ads");

    // source change from Profcyma_Google_Ads to DY_Patil_website_traffic by suggestion of saurbah sir on 08/04/26
    // formData.append("source_name", "DY_Patil_website_traffic ");
    formData.append("api_key", "profcyma-new-website");

    // online degree domain and  api key
    // formData.append("api_key", "Profcyma_Google_MBA-WX");

    // edujam domain and  api key
    // formData.append("api_key", "other");
    // formData.append("subdomain", "edujam");

    // https://onlinembainfo.com/ domain and  api key

    // formData.append("api_key", "landing-page");
    // formData.append("subdomain", "bwidesolutions");

    // skillabove domain and  api key
    // formData.append("api_key", "landing-page");
    // formData.append("subdomain", "skillabove");

    // dreammedicine domain and  api key
    // formData.append("api_key", "landing-page");
    // formData.append("subdomain", "dreammedicine");

    // ✅ Add UTM cookies
    formData.append("utm_source", Cookies.get("utm_source") || "");
    formData.append("utm_medium", Cookies.get("utm_medium") || "");
    formData.append("utm_campaign", Cookies.get("utm_campaign") || "");
    formData.append("utm_id", Cookies.get("utm_id") || "");
    formData.append("lpurl", Cookies.get("lpurl") || "");

    formData.forEach((value, key) => {
      console.log(key + ": " + value);
    });

    try {
      const res = await postEnquiryForm(formData);
      if (res?.success) {
        // ✅ Download brochure
        const link = document.createElement("a");
        link.href = "/assets/broucher/dpu_brocher_2027.pdf"; // Path to your brochure in public folder
        link.download = "Brochure.pdf"; // File name for user
        link.click();

        navigate("/thank-you");
      } else {
        console.log("res", res);
        toast.error("You've already submitted an inquiry.");
      }
    } catch (error) {
      toast.error("You've already submitted an inquiry.");
    }
  };

  const customStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      borderColor: errors.state_id ? "red" : baseStyles.borderColor,
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  };

  return (
    <div className="form-sec-start">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="form-detail">
          <Col md={12} className="p-1">
            {/* Full Name */}
            <Form.Group controlId="formGridname" className="mb-2">
              {/* <Form.Label>Full Name</Form.Label> */}
              <Form.Control
                name="name"
                className={classNames("", {
                  "is-invalid": errors?.name,
                })}
                type="text"
                {...register("name", {
                  required: "Name is required",
                  pattern: {
                    value: /^[A-Za-z ]*$/,
                    message: "Name must contain only letters",
                  },
                })}
                onKeyDown={(event) => {
                  if (!/[A-Z-a-z ]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder="Enter Full Name"
              />

              {errors.name && (
                <span className="text-danger">{errors.name.message}</span>
              )}
            </Form.Group>
          </Col>
          <Col md={12} className="p-1">
            {/* Email Address */}
            <Form.Group controlId="formGridemail" className="mb-2">
              {/* <Form.Label>Email Address</Form.Label> */}
              <Form.Control
                className={classNames("", { "is-invalid": errors?.email })}
                type="email"
                {...register("email", {
                  required: "Email Address is required",
                  pattern: {
                    value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                    message: "Invalid E-Mail Address",
                  },
                })}
                placeholder="Enter email Address"
              />
              {errors.email && (
                <span className="text-danger">{errors.email.message}</span>
              )}
            </Form.Group>
          </Col>
          <Col md={12} className="p-1">
            {/* Mobile Number */}
            <Form.Group controlId="formGridphone" className="mb-2">
              {/* <Form.Label>Mobile Number</Form.Label> */}
              <Form.Control
                className={classNames("", {
                  "is-invalid": errors?.contact_no,
                })}
                type="tel"
                {...register("contact_no", {
                  required: "Mobile Number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Mobile Number must be a 10-digit number",
                  },
                  maxLength: 10,
                })}
                onKeyDown={(event) => {
                  const key = event.key;
                  if (
                    !/^\d$/.test(key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Home",
                      "End",
                    ].includes(key)
                  ) {
                    event.preventDefault();
                  }
                }}
                placeholder="Enter Mobile Number"
                maxLength={10}
              />
              {errors.contact_no && (
                <span className="text-danger">{errors.contact_no.message}</span>
              )}
            </Form.Group>
          </Col>

          <Col md={6} className="p-1">
            <Form.Group controlId="formGridemail" className="mb-2">
              {/* <Form.Label>State</Form.Label> */}
              <Controller
                name="state_id" // name of the field
                className={classNames("", {
                  "is-invalid": errors?.state_id,
                })}
                {...register("state_id", {
                  required: "Select State",
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    placeholder="Select State"
                    styles={customStyles}
                    {...field}
                    options={statesData}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      GetAllCities(selectedOption.value);
                      setValue("state_id", selectedOption);
                      setValue("city_id", null);
                    }}
                  />
                )}
              />

              {errors.state_id && (
                <span className="text-danger">{errors.state_id.message}</span>
              )}
            </Form.Group>
          </Col>

          <Col md={6} className="p-1">
            <Form.Group controlId="formGridname" className="mb-2">
              {/* <Form.Label>City</Form.Label> */}
              <Controller
                name="city_id" // name of the field
                {...register("city_id", {
                  required: "Select City",
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    placeholder="Select City"
                    styles={customStyles}
                    {...field}
                    options={cities}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setValue("city_id", selectedOption);
                    }}
                  />
                )}
              />

              {errors.city_id && (
                <span className="text-danger">{errors.city_id.message}</span>
              )}
            </Form.Group>
          </Col>

          <Col md={12} className="p-1">
            {/* Select Course */}
            <Form.Group controlId="formGridcourse" className="mb-2">
              {/* <Form.Label>Select Highest Qualification</Form.Label> */}
              <Controller
                name="course_id" // name of the field
                {...register("course_id", {
                  required: "Select Course",
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    placeholder="Select Highest Qualification"
                    styles={customStyles}
                    {...field}
                    options={newCourses}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      GetAllSpecilization(selectedOption.value);
                      setValue("course_id", selectedOption);
                      setValue("specilization_id", null);
                    }}
                  />
                )}
              />

              {errors.course_id && (
                <span className="text-danger">{errors.course_id.message}</span>
              )}
            </Form.Group>
          </Col>

          {/* <Col md={12}>
                                    <Form.Group controlId="formGridcourse" className="mb-2">
                                        <Form.Label>Select Specilization</Form.Label>
                                        <Controller
                                            name="specilization_id" // name of the field
                                            {...register("specilization_id", {
                                                required: "Select Specilization",
                                            })}
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            borderColor: errors.specilization_id ? "red" : baseStyles,
                                                        }),
                                                    }}
                                                    {...field}
                                                    options={specilization}
                                                    onChange={(selectedOption) => {
                                                        field.onChange(selectedOption);
                                                        setValue("specilization_id", selectedOption);
                                                    }}
                                                />
                                            )}
                                        />

                                        {errors.specilization_id && (
                                            <span className="text-danger">
                                                {errors.specilization_id.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </Col> */}

          <Col md={12}>
            <Form.Group className="mb-2">
              <Form.Check
                required
                label="I agree to receive information regarding my submitted enquiry on Dr. D Y Patil Vidyapeeth - Centre For Online Learning"
                name="group1"
                type="checkbox"
                id=""
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="button-holder text-center ">
          <Submit_Btn btn_name="Submit" />
        </div>
      </Form>
    </div>
  );
};

export default Common_Form;
